import { Button, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { SimplePageWrapper } from '~/@ui/simple-page-wrapper/SimplePageWrapper'
import ArrowWhiteRightSvg from '~/@ui/_sharedSvgs/ui/ArrowRightWhite.svg?react'
import ArrowLeftNewSvg from '~/@ui/_sharedSvgs/ui/ArrowLeftNew.svg?react'
import { Link, useNavigate } from 'react-router-dom'
import SeniorVideo from './SeniorVideo.webm'

const intro = [
  {
    title: 'Začnite čerpať druhý dôchodok',
    body: 'Využite hodnotu svojej nehnuteľnosti na bezstarostné časy dôchodku.',
  },
  {
    title: 'Najprv nám o sebe poviete',
    body: 'Prvým krokom je vyplnenie osobných údajov.',
  },
  {
    title: 'Akú máte nehnuteľnosť?',
    body: 'Ďalej nám predstavíte byt alebo dom, ktorý vlastníte, aby sme spoznali jeho hodnotu.',
  },
  {
    title: 'Overíme si vašu identitu',
    body: 'Náš expert na nehnuteľnosti vás navštívi a overí vami zadané údaje.',
  },
  {
    title: 'Užite si dôchodok!',
    body: 'Teraz vám už nič nebráni v bezstarostnom živote.',
  },
]

export const WelcomeIntroPage = () => {
  const navigate = useNavigate()

  const [selectedIntro, setSelectedIntro] = useState(0)

  return (
    <SimplePageWrapper onClickBack={() => navigate('/account/register')}>
      <Stack className="h-full items-center justify-center gap-12 px-6">
        <video
          className="w-[250px] h-[250px] rounded-4d object-cover"
          autoPlay
          muted
          loop
          playsInline>
          <source src={SeniorVideo} type="video/webm" />
          Váš prehliadač nepodporuje video element.
        </video>

        <Stack className="gap-3">
          <Typography className="text-xl font-bold text-zBlack200 text-center">
            {intro[selectedIntro].title}
          </Typography>
          <Typography className="text-3d font-medium text-zGrey400 text-center">
            {intro[selectedIntro].body}
          </Typography>
        </Stack>

        <Stack className="flex-row w-full justify-between items-center">
          <Button
            className="w-16 h-11 bg-zGrey200 flex-shrink-0"
            disabled={selectedIntro <= 0}
            onClick={() => setSelectedIntro((prev) => prev - 1)}>
            <ArrowLeftNewSvg />
          </Button>

          {selectedIntro >= intro.length - 1 ? (
            <Button
              component={Link}
              to="/account/register/vlastnik"
              variant="contained"
              className="w-full max-w-[342px] h-14 gap-2 ml-4">
              Poďme na to
              <ArrowWhiteRightSvg />
            </Button>
          ) : (
            <>
              <Stack className="flex-row gap-3">
                {intro.map((item, index) => (
                  <Stack
                    key={`intro-dot-${item.title}`}
                    className={`w-3d h-2.5 rounded ${index <= selectedIntro ? 'bg-zBlack200' : 'bg-zGrey200'}`}
                  />
                ))}
              </Stack>

              <Button
                className="w-16 h-11 bg-zGrey200 my-1.5"
                disabled={selectedIntro >= intro.length - 1}
                onClick={() => setSelectedIntro((prev) => prev + 1)}>
                <ArrowLeftNewSvg className="rotate-180" />
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </SimplePageWrapper>
  )
}
